import { useMatches } from 'react-router';

import type { SearchPagePropsSerialized } from '@shared/types/search-page-props';

type RouteData = {
  props: SearchPagePropsSerialized;
};

export const useSearchEntity = () => {
  const matches = useMatches();

  if (!matches?.length) {
    return { entityId: undefined, nationId: undefined };
  }

  const lastMatch = matches[matches.length - 1];
  const props = (lastMatch?.data as RouteData)?.props;

  if (!props) {
    return { entityId: undefined, nationId: undefined };
  }

  const { entityId, nationId } = props;

  return {
    entityId,
    nationId,
  };
};
